@if(tooltip() != undefined && tooltip() != null && tooltip() != '') {
<app-tooltip text="{{ isDisabled() ? 'Disabled' : tooltip()! }}" [position]="position()">
    <button [disabled]="isDisabled()" type="button"
        class="{{ bgColor() }} {{ textColor() }} text-{{ size() }} disabled:text-primary-200 {{ size() == 'sm' ? 'h-10 w-10 max-h-10 max-w-10' : 'h-6 w-6 max-h-6 max-w-6' }} rounded-md focus:outline-none outline-none ease-linear transition-all duration-150">
        <i class="{{ icon() }}"></i>
    </button>
</app-tooltip>
} @else {
<button [disabled]="isDisabled()" type="button"
    class="{{ bgColor() }} {{ textColor() }} text-{{ size() }} disabled:text-primary-200 {{ size() == 'sm' ? 'h-10 w-10 max-h-10 max-w-10' : 'h-6 w-6 max-h-6 max-w-6' }} rounded-md focus:outline-none outline-none ease-linear transition-all duration-150">
    <i class="{{ icon() }}"></i>
</button>
}